package br.com.vvrefeicoes.portal.core.util

import kotlinx.browser.document
import kotlinx.browser.window
import org.w3c.dom.HTMLElement
import org.w3c.dom.Window

private var preparedFileWindow: Window? = null

actual fun saveFile(
    fileName: String,
    mimeType: String,
    bytes: ByteArray,
): Boolean {
    val anchor = document.createElement("a")
    anchor.setAttribute("href", "data:$mimeType;base64,${encodeBase64(bytes)}")
    anchor.setAttribute("download", fileName)
    (anchor as HTMLElement).click()
    return true
}

actual fun isFileExportSupported(): Boolean = true

actual fun prepareFileBrowserTab(): Boolean {
    preparedFileWindow = window.open("", "_blank")
    return preparedFileWindow != null
}

actual fun openExternalUrl(url: String): Boolean {
    val target = preparedFileWindow
    preparedFileWindow = null
    if (target != null) target.location.href = url else window.open(url, "_blank", "noopener,noreferrer")
    return true
}

actual fun openFileInBrowser(
    fileName: String,
    mimeType: String,
    bytes: ByteArray,
): Boolean {
    val url = "data:$mimeType;base64,${encodeBase64(bytes)}"
    val target = preparedFileWindow
    preparedFileWindow = null
    if (target != null) {
        target.location.href = url
    } else {
        window.open(url, "_blank", "noopener,noreferrer")
    }
    return true
}
